import { useEffect, useState } from "react";
import { Users } from "lucide-react";
import { http } from "../../lib/api";

const NONE = "GÖREV GİRİLMEMİŞ";
const today = () => new Date().toISOString().slice(0, 10);

// Şube kartı: bu şubede çalışan aktif personelin görev bazlı dökümü (örn. 3 TEMİZLİK GÖREVLİSİ · 1 ŞEF)
export default function LocDutySummary({ locationId }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    setRows(null);
    http.get(`/personnel?location_id=${locationId}`).then((r) => setRows(r.data.filter((p) => p.status === "Aktif" && (!p.leave_date || p.leave_date > today())))).catch(() => setRows([]));
  }, [locationId]);
  if (!rows) return null;
  const groups = Object.entries(rows.reduce((m, p) => { const k = p.duty || NONE; m[k] = (m[k] || 0) + 1; return m; }, {})).sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0], "tr"));
  return (
    <div className="flex items-center gap-2 flex-wrap text-[11px] border-t border-slate-100 pt-3" data-testid="loc-duty-summary">
      <span className="inline-flex items-center gap-1 font-semibold uppercase tracking-wider text-slate-600"><Users className="w-3.5 h-3.5" /> Şube Personeli (<span data-testid="loc-duty-total">{rows.length}</span>)</span>
      {groups.length === 0 && <span className="text-slate-400" data-testid="loc-duty-empty">Bu şubeye kayıtlı aktif personel yok</span>}
      {groups.map(([duty, n]) => (
        <span key={duty} data-testid={`loc-duty-${duty === NONE ? "none" : duty}`} title={duty === NONE ? "Personel kartında Görevi alanı boş" : ""}
          className={`px-2 py-0.5 rounded-full border font-semibold ${duty === NONE ? "border-amber-300 bg-amber-50 text-amber-800" : "border-slate-300 bg-slate-50 text-slate-800"}`}>
          <b>{n}</b> {duty}
        </span>
      ))}
    </div>
  );
}
